export default "__VITE_ASSET__BtAVoAWA__"